export const WATER_DOCTOR_ORGANIZATION_ID = "https://waterdoctor.ca/#organization";
export const WATER_DOCTOR_LOCAL_BUSINESS_ID = "https://waterdoctor.ca/#localbusiness";
export const WATER_DOCTOR_WEBSITE_ID = "https://waterdoctor.ca/#website";

export const WATER_DOCTOR_CORE = Object.freeze({
  name: "Water Doctor",
  url: "https://waterdoctor.ca",
  logo: "https://waterdoctor.ca/waterdoctor-logo.png",
  image: "https://waterdoctor.ca/waterdoctor-logo.png",
  telephone: "+1-289-748-9666",
  address: Object.freeze({
    "@type": "PostalAddress",
    streetAddress: "601 Denison St",
    addressLocality: "Markham",
    addressRegion: "ON",
    postalCode: "L3R 1B8",
    addressCountry: "CA",
  }),
});
